import { configure } from 'axios-hooks';
import Axios, { AxiosError } from 'axios';

const axios = Axios.create({
  baseURL: process.env.REACT_APP_API_URL ?? '',
});

axios.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem('token');

    if (token) {
      config.headers.set('token', token);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => {
    if (response?.data?.token) {
      localStorage.setItem('token', response.data.token);
    }
    return response;
  },
  async (error: AxiosError<any>) => {
    if (error?.response?.status === 401) {
      window.location.href = new URL(process.env.PUBLIC_URL.concat('/login'), window.location.href).href;
      return Promise.reject(error);
    }

    /*if (error?.response?.status && error?.response?.status >= 400 && error?.response?.status < 500) {
      showToast({
        status: 'error',
        title: 'Revisar los campos con errores',
        message: (
          <Fragment>
            <Text>
              En caso de no poder continuar con su solicitud luego de reintentar, por favor, comunicarse al siguiente mail:{' '}
              <a href={`mailto:${process.env.REACT_APP_RRHH_EMAIL}`}>{process.env.REACT_APP_RRHH_EMAIL}</a> indicando el siguiente código de identificación de la operación:
            </Text>
            <Text style={{ display: 'flex', justifyContent: 'space-between' }}>
              {error?.response?.data?.traceId}
              {<Icon as={MdOutlineContentCopy} onClick={copyToClipboard(error?.response?.data?.traceId)} title="Copiar" cursor="pointer"></Icon>}
            </Text>
          </Fragment>
        ),
      });
    }*/

    return Promise.reject(error);
  }
);

configure({ axios });
